import { useEffect } from 'react';

export function useRegisterServiceWorker() {
  useEffect(() => {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('service worker registered successfully:', registration);
        })
        .catch((error) => {
          console.log('service worker registration failed:', error);
        });
    });
  }, []);
}
